export default __webpack_public_path__ + "static/bitfinex-76600883f81d98a938a47230959dd69c.svg";